import React, { useState,useEffect } from "react";
import { Container, Navbar, Nav, Offcanvas,Button } from "react-bootstrap";
import { useNavigate, BrowserRouter as Router } from "react-router-dom";
import Payment from "./Payment"; 
function Navbar1()
{
    const [show, setShow] = useState(false);
    const navigate = useNavigate();
    const [showPaymentModal, setShowPaymentModal] = useState(false);
  //   const handleLogout = () => {
  //     sessionStorage.clear();
  //     localStorage.clear();
  //     navigate("/");
  // };
    
  const handleLogout = () => {
    const confirmLogout = window.confirm("Do you want to exit this app?");
    if (confirmLogout) {
        sessionStorage.clear();
        localStorage.clear();
        navigate("/login.html");
    }
};

// useEffect(() => {
//   const script = document.createElement("script");
//   script.src = "https://checkout.razorpay.com/v1/checkout.js";
//   script.async = true;
//   script.onload = () => console.log("Razorpay script loaded successfully.");
//   script.onerror = () => console.error("Failed to load Razorpay script.");
//   document.body.appendChild(script);
// }, []);

    return(
    <>
    <Navbar expand={false}>
        <Container>
          <Navbar.Toggle aria-controls="offcanvasNavbar" className="me-auto" onClick={() => setShow(true)} />
        </Container>
      </Navbar>

      {/* <Navbar expand={false}>
        <Container fluid className="d-flex justify-content-between align-items-center">
          
          <Button 
            className="btn btn-outline-primary d-flex align-items-center justify-content-center me-auto" 
            style={{ backgroundColor: "#6200ea", color: "white", width: "40px", height: "40px", borderRadius: "5px" }} 
            onClick={() => setShow(true)}
          >
           <List size={96} color="white" className="align-top" />
   
          </Button>
        </Container>
      </Navbar>  */}
      {/* Sidebar Offcanvas */}
      <Offcanvas show={show} onHide={() => setShow(false)} placement="start">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Menu</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Nav className="flex-column">
          <Nav.Link onClick={() => navigate("/profile")}>Profile</Nav.Link>
          <Nav.Link onClick={() => navigate("/landing")}>Home</Nav.Link>
          <Nav.Link onClick={() => navigate("/home")}>OP</Nav.Link>
          <Nav.Link onClick={() => navigate('/view')}>View</Nav.Link>
          <Nav.Link onClick={() => setShowPaymentModal(true)}>Payment</Nav.Link>
          <Nav.Link onClick={() => navigate('/invoice')}>Invoice</Nav.Link>
          <Nav.Link onClick={() => navigate('/insulin')}>Insulin</Nav.Link>
          {/* <Nav.Link onClick={() => navigate('/fileview')}>File View</Nav.Link> */}
          {/* <Nav.Link onClick={() =>navigate("/")}>Sign out</Nav.Link> */}
          <Nav.Link onClick={() => handleLogout()} >Sign out</Nav.Link>
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>
      {/* ✅ Razorpay Payment Modal */}
      <Payment show={showPaymentModal} handleClose={() => setShowPaymentModal(false)} />
    </>
    );
}
export default Navbar1;